import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0DatePicker } from '@factorialco/f0-react'
import type { DatePickerValue } from '@factorialco/f0-react/dist/experimental'
import { endOfMonth, startOfMonth } from 'date-fns'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import type ReportsForm from 'modules/employees/lib/forms/Reports'

interface Props {
  form: ReportsForm
}

const ExportMonthSelector = ({ form }: Props) => {
  const startDate = form.get('from')
  const endDate = form.get('to')

  const startDateValue = React.useMemo(() => {
    if (!startDate.value) return undefined
    const date = stringToDate(startDate.value, 'ui').toDate()
    return {
      granularity: 'month' as const,
      value: {
        from: startOfMonth(date),
        to: endOfMonth(date),
      },
    }
  }, [startDate.value])

  const endDateValue = React.useMemo(() => {
    if (!endDate.value) return undefined
    const date = stringToDate(endDate.value, 'ui').toDate()
    return {
      granularity: 'month' as const,
      value: {
        from: startOfMonth(date),
        to: endOfMonth(date),
      },
    }
  }, [endDate.value])

  const handleStartDateChange = (
    date: DatePickerValue | undefined,
    _stringValue?: string | undefined
  ) => {
    if (date?.value?.from) {
      const formattedDate = i18nDateToString(startOfMonth(date.value.from), 'ui')
      startDate.set(formattedDate)
    }
  }

  const handleEndDateChange = (
    date: DatePickerValue | undefined,
    _stringValue?: string | undefined
  ) => {
    if (date?.value?.from) {
      const formattedDate = i18nDateToString(startOfMonth(date.value.from), 'ui')
      endDate.set(formattedDate)
    }
  }

  return (
    <>
      <FormRow>
        <Box gap="s16" flexDirection="row" width="full">
          <Box style={{ flex: '1' }}>
            <F0DatePicker
              label={i18n.t('common.starting_from')}
              onChange={handleStartDateChange}
              size="sm"
              value={startDateValue}
              granularities={['month']}
            />
          </Box>
          <Box style={{ flex: '1' }}>
            <F0DatePicker
              label={i18n.t('common.ending_at')}
              onChange={handleEndDateChange}
              size="sm"
              value={endDateValue}
              granularities={['month']}
            />
          </Box>
        </Box>
      </FormRow>
    </>
  )
}

export default observer(ExportMonthSelector)
